import { TableRow, TableCell } from '@mui/material'

const TestCaseAssertion = ({ testCase }) => {
  const stepIndex = (testCase?.steps?.length || 0) + 1
    const resultElements = testCase?.result_elements || []
    console.log("testCase assertion!!!: ", testCase);

  const renderLabel = () => {
    if (testCase?.is_positive) {
      return `Expected result:`;
    }

    if (testCase?.common_result === 'SUCCESS') {
      return `Assert the error message:`
    }

    const hasText = resultElements[0]?.text;
    return `Assert the error message${hasText ? ':' : ''}`
  }

  const renderResults = () => {
    // if (resultElements.length > 0) {
    //     <ul style={{ paddingLeft: '1.5em', margin: 0 }}>
    //       {resultElements.map((el, idx) => (
    //         <li key={idx} style={{ lineHeight: 1.6 }}>&quot;{el.text}&quot;</li>
    //       ))}
    //     </ul>
    // }

    // if (testCase?.is_positive) {
    //     return testCase?.common_result;
    // }

    return testCase?.description;
  }

  return (
    <TableRow
      className='stepsAccordionTableBodyRow'
      sx={{
        backgroundColor:
          testCase?.common_result === 'SUCCESS'
            ? 'rgba(25, 135, 84, 0.1)'
            : testCase?.common_result === 'FAILED'
            ? 'rgba(211, 47, 47, 0.1)'
            : 'inherit'
      }}
    >
      <TableCell className="stepsAccordionTableBodyCell stepsAccordionIndex">
        {stepIndex}
      </TableCell>
      <TableCell className="stepsAccordionTableBodyCell">
        <strong>{renderLabel()}</strong>
      </TableCell>
      <TableCell className="stepsAccordionTableBodyCell">
        {renderResults()}
      </TableCell>
    </TableRow>
  )
}

export default TestCaseAssertion